export default {
  local: {
    'zh-CN': 'Chinese',
    'en-US': 'English(US)',
  },
  common: {
    404: '404 Message',
    wel: 'Welcome to ACS system ',
    sn: 'sn',
    slogan: 'slogan',
    guide: 'guide',
    pageTitle: {
      costCenter: 'Cost Centre Manage',
      personCostCenter: 'Personnel Cost Center',
      personalCostCenter: 'Personnel Cost Center',
      matchRelation: 'Match Relationship Configuration',
      proLin: 'Product Line',
      checkProLin: 'View Product Line',
      virtualTeame: 'Virtual Team',
      virtualTeameConfig: 'Virtual Team Config',
      checkTeame: 'View Team Details',
      syncManagement: 'Sync Management',
      menuManagement: 'Menu Management',
      userManagement: 'User Management',
      userManagementDetail: 'User Detail',
      orgManagement: 'Org Management',
      roleManagement: 'Role Management',
      roleManagementEdit: 'Role Rights Management',
      dataDictionary: 'Data Dictionary',
      loginLog: 'Login log',
      operationLog: 'Operation Log',
      internationConfig: 'Internation Config',
      materialInformation: 'Material Information',
      accountManage: 'Account Manage',
      accountDetail: 'Account Detail',
      changeLog: 'Change Record',
      roleManage: 'Role management',
      roleDetail: 'Role Detail',
      myPermission: 'My Permission',
      personalPermission: 'Personal Permission',
      ppManage: 'Permission Point Management',
      subordinate: 'Subordinate Permission',
      permissionUsers: 'Authorized Users',
      apply: 'Permission Application',
      taskDetail: 'Task Detail',
      checkReport: 'Employee Review Report',
      groupReport: 'Group Review Report',
      reportDetail: 'Review Report Detail',
      logRolePoint: 'Role/Permission Log',
      logPerson: 'Personnel Log',
    },
    org: {
      deptName: 'Department name',
    },
    excel: {
      import: 'Import',
      importModel: 'Import template',
      readyData: 'Prepare Data',
      downloadModule: 'Download Template',
      downloadTips1: 'Please confirm that all fields are set according to the template rules;',
      downloadTips2: 'Otherwise, the whole file importing will be failed;',
      importData: 'Import Data',
      updateFile: 'Upload File',
      supportExtra: 'Supported File types',
      downloadName: '{name} template',
    },
    bt: {
      reset: 'Reset',
      refresh: 'Refresh',
      Closeleft: 'Close left',
      Closeright: 'Close right',
      Closeothers: 'Close others',
      Closerall: 'Closer all',
    },
    config: {
      configAll: 'All',
      levelHigh: 'High',
      levelMedium: 'Medium',
      levelLow: 'Low',
      levelNone: 'None',
      levelDefault: 'Default',
      typeView: 'Access',
      typeFunction: 'Function',
      typeData: 'Data',
      statusNormal: 'Normal',
      statusInvalid: 'Invalid',
      statusExpire: 'Expired soon',
      checkStatusInit: 'In Progress',
      checkStatusAllComplete: 'Done',
      checkStatusEndInit: 'Expiration Auto-Completion',
      checkStatusEndAllComplete: 'Done',
      statusAdd: 'Add',
      statusModify: 'Modify',
      statusRemove: 'Remove',
      statusRemoveHard: 'Hard Remove',
      statusSyncAdd: 'Sync Add',
      statusSyncUpdate: 'Sync Update',
      statusSyncDisable: 'Sync Disable',
      statusRecycleDisable: 'Recycle Disable',
      statusExpireDisable: 'Expire Disable',
      statusAppDisable: 'App Disable',
    },
    field: {
      affiliatedApp: 'appNameEn',
      appName: 'nameEn',
      ppName: 'enName',
      ppDesc: 'descEn',
      roleName: 'nameEn',
      roleDesc: 'descEn',
      ppRoleName: 'roleNameEn',
      ppRoleDesc: 'roleDescEn',
      associatedPpName: 'permissionNameEn',
      menuName: 'nameEn',
      relateName: 'relateNameEn',
      userName: 'userNameEn',
      managerName: 'nameEn',
      departmentName: 'departmentNameEn',
      ownerName: 'ownerNameEn',
      ownerUserName: 'ownerUserNameEn',
      sysName: 'sysNameEn',
      taskName: 'taskNameEn',
      periodName: 'enName',
      descName: 'descEn',
      operatorName: 'operatorName',
    },
    choose: {
      subordinate: 'Subordinate',
      userName: 'enName',
      deptName: 'enName',
      userDeptName: 'deptEnName',
      parentName: 'parentEnName',
      dept: 'dept',
      user: 'user',
      menuName: 'nameEn',
    },
    table: {
      number: 'No',
      affiliatedApp: 'Affiliated Application',
      menu: 'Connection Menus',
      ppIdentifier: 'Permission Point Identifier',
      ppiName: 'Permission Point Identifier/Name',
      authorizeName: 'Permission Name',
      ppLevel: 'Permission Point Level',
      ppType: 'Permission Point Type',
      ppName: 'Permission Point Name',
      ppNameEn: 'Permission Point Name En',
      ppDesc: 'Permission Point Description',
      ppDescEn: 'Permission Point Description En',
      ppDescTip: 'Permission Point Description(no more than 100 words)',
      ppDescTipEn: 'Permission Point Description En(no more than 100 words)',
      ppManager: 'Permission Point Manager',
      createPoint: 'Create Permission Point',
      editPoint: 'Edit Permission Point',
      operate: 'Operation',
      rolePermission: 'Role Permission',
      permissionPoint: 'Permission Point',
      roleName: 'Role Name',
      roleNameEn: 'Role Name En',
      roleManager: 'Role Manager',
      roleIdentifier: 'Role Identifier',
      roleDesc: 'Role Description',
      roleDescEn: 'Role Description En',
      roleDescTip: 'Role Description(no more than 100 words)',
      roleDescTipEn: 'Role Description En(no more than 100 words)',
      role: 'Role',
      status: 'Status',
      remainTime: 'Remaining Time',
      disableTime: 'Disabled Time',
      grantTime: 'Grant Time',
      employeeName: 'Employee Name',
      personal: 'Personal',
      associatedPp: 'Associated Permission Point',
      associatedPpAdd: 'Add Associated Permission Point',
      subOnly: 'Immediate Subordinates',
      yes: 'Yes',
      no: 'No',
      sureRemoveRole: 'Are you sure to remove this role?',
      createRole: 'Create Role',
      editRole: 'Edit Role',
      isApply: 'Whether Applicable',
      isEffective: 'Effective or not',
      isManagerControl: 'Whether Revocable',
      permissionValidity: 'Permission validity',
      roleValidity: 'Role validity',
      editMulti: 'Batch modification of expiration date',
      editPeriod: 'Modify expiration date',
      validity: 'Validity',
      userName: 'User Name',
      userAccount: 'User Account',
      userAdd: 'Add User',
      defaultAuth: 'Default Authorizer',
      defaultAuthDept: 'Default Authorizing Dept.',
      regularEmployee: 'Regular Employee',
      uutsourcedEmployee: 'Outsourced Employee',
      externalUuser: 'External User',
      overseasUser: 'Overseas User',
      selectDept: 'Select Dept.',
      revokePermissionTip: 'Are you sure to revoke permissions?',
      userQuery: 'user name、phone number、account',
      removeRoleTip: 'Are you sure you want to remove this role？',
      disassociationTip: 'Are you sure to disassociation？',
      selected: 'Selected',
      pleaseSearch: 'Please Search',
      employee: 'Employee',
      department: 'Dept.',
      revokeDisableTip:
        'The permission point has not yet been connected to automatic recycling. Please contact the system administrator to recycle the corresponding permissions',
      requiredMes: 'This is required',
      periodTo: 'to',
      lowerFileName: 'Subordinate Permissions.xlsx',
      ppUsersFileName: 'Permission Point Authorized Users.xlsx',
      days: 'days',
      checkStatus: 'Check Status',
      checkReport: 'Check Report',
      createTime: 'Review Period',
      completeTime: 'Complete Time',
      taskStepOne: 'Review Permissions',
      taskStepTwo: 'Recycle(if necessary)',
      taskStepThree: 'Submit the results of the review',
      taskTitle: 'Permission Review',
      taskDeadline: 'Deadline',
      taskDesc: 'Description',
      taskDesc1_1:
        '1. Please complete the permission review of your subordinates before reaching the completion deadline. You need to review the rationality of the ',
      taskDesc1_2: 'the Role Permission and Permission Point ',
      taskDesc1_3:
        'allocation respectively. If you find permissions that should not be granted, please revoke them immediately.',
      taskDesc2:
        '2. We will send you a permission review report after the task is completed; if the task is not completed, the system will expire and automatically complete, and the result of the review report will be unreviewed by default. The results of the review will be reported to the CFO.',
      taskSubmit: 'Submit the results of the review',
      taskHistory: 'Historical Review Records',
      reviewResult: 'Review results',
      roleReviewResult: 'Role review results',
      permissionPointReviewResult: 'Permission point review results',
      taskSubmitConfirm: 'Are you sure to submit the results of the review?',
      referenceMaterial: 'Reference Material',
      taskCompleteTime: 'Task Completion Date',
      taskReportTime: 'Report Generation Date',
      taskStatus: 'Task Status',
      reportFileName: 'Review Report',
      statusUnnecessary: 'Reviewed and unrevoked',
      statusUnreviewed: 'Unreviewed',
      statusDisable: 'Reviewed and revoked',
      reviewer: 'Reviewer',
      reportPointTips:
        'Only the review results of medium and high-risk permission points are displayed.',
      accountName: 'Account',
      rolePointId: 'Role/Permission ID',
      roleId: 'Role ID',
      pointId: 'Permission ID',
      rolePointName: 'Role/Permission Name',
      pointName: 'Permission Name',
      operateTime: 'Operate Time',
      dataRange: 'Data Range',
      dataRangeString: 'Data Range',
      extra: 'Extra',
      operationLog: 'Operation Log',
      viewLog: 'View Log',
    },
    btn: {
      reset: 'Reset',
      loadMore: 'Load more',
      selectUser: 'Select the user',
      import: 'Import',
      export: 'Export',
      roleEdit: 'Member groups & permissions',
      info: 'Details',
      locked: 'Locked',
      add: 'Add',
      submit: 'Submit',
      addChild: 'Add child',
      edit: 'Edit',
      authorize: 'Authorize',
      del: 'Delete',
      cancel: 'Cancel',
      sure: 'OK',
      show: 'Show',
      search: 'Search',
      advanceSearch: 'Advanced filter',
      sync: 'Sync',
      save: 'Save',
      sureDel: 'Do you sure to delete?',
      svaeC: 'Save and continue',
      setRight: 'Set permissions',
      ppRelate: 'Associated Permission Point',
      revoke: 'Revoke Permission',
      editPeriod: 'Modify Expiration Date',
      removeRole: 'Remove Role',
      disassociation: 'disassociation',
      apply: 'Apply for permission',
      collapse: 'Collapse',
      detail: 'Detail',
      preview: 'View',
      download: 'Download',
      previewFile: 'Preview File',
      renewal: 'Renewal',
    },
    mes: {
      noCurAndChild:
        'The selected department cannot be a current department or a subordinate department',
      delSuc: 'Successfully deleted',
      addSuc: 'Added successfully',
      addFail: 'Added failed',
      editSuc: 'Modify successfully',
      editFail: 'Modify failed',
      delerr: 'Deletion failed',
      comSys: 'General system',
      sureDel: 'Are you sure you want to delete',
      isDelSelData: 'Are you sure you want to delete the selected data?',
      syncSys: 'Please select the system to synchronize！',
      atLeastOne: 'Please select a data to delete',
      atLeastEdit: 'Please select at least one piece of data to edit',
      swlMoreMenu: 'Are you sure you want to delete more than one menu?',
      permissonRevokeTip: 'Permission revoking successful',
      roleRevokeTip: 'Role permission revoking successful',
      selectPersonDept: 'Please select a person or department first',
      selectPerson: 'Please select a person first',
      periodSuccess: 'Permission validity period modified successfully',
      userSuccess: 'User added successfully',
      selectPp: 'Please select a permission point first',
      associationSuccess: 'Permission points associated Successfully',
      disassociationSuccess: 'Permission points disassociated Successfully',
      pointDeleteTip:
        'This permission point is already associated with users and cannot be restored after deletion. Are you sure you want to delete the permission point?',
      pointDeleteSecondTip:
        'The permission point is about to be deleted. Once confirmed, the permission point will be deleted',
      pointDeleteConfirm: 'Permission point deletion confirmation',
      roleDeleteTip:
        'This role is already associated with users and cannot be restored after deletion. Are you sure you want to delete this role?',
      roleDeleteSecondTip:
        'The role is about to be deleted. Once confirmed, the role will be deleted',
      roleDeleteConfirm: 'Role deletion confirmation',
      taskSuccessTitle: 'The review task has been completed',
      taskSuccessContent1:
        'The permission review report has been generated. You can directly click the button below to view it, or you can view it later in Subordinate Permissions - Historical Review Records.',
      taskSuccessContent2:
        'It is also important to manage the permissions of subordinates in daily work, develop good habits, and ensure the information security of the company.',
      taskSuccessConfirm: 'I got it',
      taskSuccessCancel: 'View the report',
      querySelectAtLeast: 'Please select a application or employee at least',
      noTaskDetail: 'No task details',
      selectApp: 'Please select an application',
      selectAppAndRole: "Please select the precondition first",
    },
    user: {
      userRetainAD: 'Internal users retain enterprise WeChat and AD',
      noSyncSF: 'Resignation out of sync SF',
      sn: 'Number',
      peo: 'Personnel',
      operation: 'Operation',
      inside: 'Inner',
      outside: 'External',
      loginStatus: 'Login status',
      inputSearch: 'Enter search Department',
      userStatus: 'User status',
      userStatusSel: 'Please select status',
      user: 'User',
      userHold: 'name/account/number/mobile number',
      createS: 'Generate key',
      sureResetPas: 'Are you sure you want to reset the password',
      pasReset: 'Password Reset',
      sureStart: 'Confirm enable？',
      start: 'Enable',
      sureForb: 'Are you sure you want to disable it？',
      syncPeo: 'Personnel synchronization',
      syncDate: 'Synchronization date',
      account: 'Account',
      accountInput: 'Please enter the account number',
      mailPre: 'Mailbox prefix',
      name: 'Name',
      nameInput: 'Please enter your name',
      chName: 'Chinese name',
      dept: 'Department',
      deptName: 'Department name',
      pos: 'Station',
      location: 'Location',
      mobile: 'Mobile phone number',
      mobileInput: 'Please input mobile phone number',
      max11: 'Up to 11',
      onlyNum: 'Only numbers',
      email: 'Email',
      emailInput: 'Please input email',
      desc: 'Remarks',
      descInput: 'Please input remarks',
      timeRange: 'Effective date',
      role: 'Role',
      userType: 'User type',
      roleInput: 'Input keyword fuzzy query',
      normal: 'Normal',
      forb: 'Forbidden',
      pleaseSelDept: 'Please select Department',
      sCreSus: 'Generate key successfully, please check email',
      pasResetSus: 'Password reset successful',
      addPeople: 'Add users',
      editPeople: 'Modify user',
    },
    addExtra: {
      department: 'Department',
      buildDepartment: 'New Department',
      search: 'Search',
      reset: 'Reset',
      using: 'Using',
      deleted: 'Deleted',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      mainTable: {
        departmentName: 'Department Name',
        buildTime: 'Create Time',
        builder: 'Create By',
        updateTime: 'Update Time',
        updater: 'Updated by',
        operation: 'Operation',
      },
      deleteTable: {
        departemntName: 'Department Name',
        buildTime: 'Create Time',
        builder: 'Create By',
        deleteTime: 'Delete Time',
        deleter: 'Delete By',
      },
      deleteSuccess: 'Delete Success',
      deleteError: 'Delete Fail',
      departmentConfig: 'Department Information',
      departmentEdit: 'Edit Department',
      departmentAdd: 'New Department',
      addModal: {
        departmentName: 'Department Name',
        inputDepartmentName: 'Enter the  name of the Department',
        departmentNameEn: 'Department Name(EN)',
        inputeDepartmentNameEn: 'Enter the English name of the Department',
        departentCharger: 'Department Head',
        inputCharger: 'Please enter the person in charge of the Department',
        upperDepartment: 'Superior department',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      editModal: {
        pleaseInputDepartmentName: 'Please Enter The Department Name',
        departmentCode: 'Department Code',
        departmentName: 'Department Name',
        inputDepartmentName: 'Enter Department Name',
        departmentNameEn: 'Department Name(EN)',
        inputeDepartmentNameEn: 'Enter the English name of the Department',
        departmentCharger: 'Department Head',
        inputDepartmentCharger: 'Please enter the person in charge of the Department',
        upperDepartment: 'Superior department',
        selectUpperDepartment: 'Please select superior department',
        del: 'Delete',
        buildTime: 'Create Time',
        builder: 'Create By',
        modifyTime: 'Last Modified Time',
        modifyer: 'Last Modified By',
        cancel: 'Cancel',
        comfirm: 'Comfirm',
      },
      detailModal: {
        departmentCode: 'Department Code',
        departmentName: 'Department Name',
        departmentNameEn: 'Department Name(EN)',
        upperDepartment: 'Superior Department',
        upperCharger: 'Department Head',
        costCenterCode: 'Cost Center Code',
        HRBP: 'HRBP',
        businessBP: 'Property BP',
        resourceManager: 'Asset Manager',
        buildTime: 'Create Time',
        builder: 'Create By',
        modifyTime: 'Lasr Modified Time',
        modifyer: 'Last Modified By',
      },
      changeLog: {
        source: 'Source',
        time: 'Time',
        operateByPerson: 'Human Operation',
        all: 'All',
        timingTask: 'Scheduled Task Update',
        engin: 'Process Engine',
        messageQueue: 'Message Queuing Processing',
        search: 'Search',
        table: {
          operateTime: 'Operate Time',
          modal: 'Modal',
          name: 'name',
          source: 'Source',
          modifyType: 'Modification type',
          modifyfield: 'Modify field',
          modifyBeforeContent: 'Before Content',
          modifyAfterContent: 'After Content',
        },
      },
    },
    menu: {
      modal: {
        add: 'Add menu',
        edit: 'Edit menu',
      },
    },
    apply: {
      system: 'System',
      content: 'Reason',
      period: 'Valid Period',
      addPoint: 'Add Permission Point',
      addRole: 'Add Role',
      submit: 'Submit',
      submitTip: 'Are you sure to submit？',
      deleteTip: 'Are you sure to delete？',
      selectPoint: 'Select Permission Point',
      selectRole: 'Select Role',
      selectSystem: 'Select System',
      roleManager: 'Role Manager',
      name: 'System Name',
      nameEn: 'System Name(EN)',
      serviceName: 'Service Name',
      description: 'System Description',
      managerName: 'System Manager',
      submitSuccess: 'Successful',
      maxLength: 'Enter up to 500 words',
      selectSystemFirst: 'Please a select system first',
      changeSystemTip:
        'Change system will clear the role and permission point what you have choosen, Are you sure to change',
      otherTip:
        'When the desired system cannot be found, please select Other and then elaborate on it in the application reason',
      submitPrevTip: 'Please select one role or permission point at least!',
      seeMyPermission: 'See my permission',
      moreQuestions: 'If you have more questions, you can check',
      ITService: 'IT Service',
      consult: 'Or consult',
      applyTime: 'en',
      successTipLeft:
        'Your permission application has been submitted successfully. Please go to the',
      successTipCenter: 'Approval Center - My Application',
      successTipRight: 'to check the approval progress',
      noData: 'No Data',
      select: 'Select',
      selectRolePoint: 'Select Role/Permission Point',
      selectDataRangeTip: 'Please select the data range',
      selectDataRange: 'Select Data Range',
    },
  },
  pages: {
    login: {
      ecarx: 'Master data management system',
      title: 'Welcome',
      bt: 'Sign in',
      placeholder: {
        username: 'Please input account',
        password: 'Please input password',
      },
      code: 'Verification Code',
      loginErr: 'Login failed. Please check the user name and password!',
      codeErr: 'Verification code input error',
    },
    sys: {
      btn: {
        addDict: 'Add data dictionary',
        editDict: 'Modify data dictionary',
        showDict: 'View data dictionary',
      },
      dict: {
        dataType: 'Data dictionary type',
        pHold1: 'Please input the code or name',
        pHoldCode: 'Please input data item code',
        pHoldName: 'Please input the name of the data item',
        check1Mes: 'Please enter letters, numbers and underscores',
        check2Mes: 'Up to 15',
        check3Mes: 'Up to 25 ',
        rule1: 'Please input letters or numbers',
        mes1: 'Data item code cannot be repeated!',
        dataList: 'Data item',
      },
      log: {
        name: 'Name',
        inputName: 'Please input name',
        system: 'System',
        rolename: 'Role name',
        selectSys: 'Please select system',
        type: 'Type',
        selectType: 'Please select type',
        outTime: 'Logout time',
        inputLoginIp: 'Please enter login IP',
      },
      config: {
        infoCode: 'Information encoding',
        inputInfoCode: 'Please input the information code',
        inputDesc: 'Please input description',
        zhDesc: 'Description (Simplified Chinese)',
        enDesc: 'Description (American English)',
      },
      table: {
        sn: 'Number',
        code: 'Data item code',
        name: 'Data item name',
        lock: 'Locked',
        typeCode: 'Data dictionary type code',
        inputTypeCode: 'Please input data dictionary type code',
        inputTypeName: 'Please input the data dictionary type name',
        typeName: 'Data dictionary type name',
        createBy: 'Creater',
        createTime: 'Creation time',
        modifiedBy: 'Reviser',
        modifiedTime: 'Revision time',
        optBtn: 'Operation',
        logSys: 'login system',
        logIp: 'Login IP',
        time: 'Time',
        date: 'Date',
        optUser: 'Operator',
        optSys: 'Operation system',
        optTime: 'Operation time',
        selOptUser: 'Please enter operator',
        optEve: 'Operation event',
        selOptEve: 'Please enter the operation event',
        logStatus: 'Log status',
        params: 'Parameter',
        selLogStatus: 'Please select status',
      },
    },
    user: {
      org: {
        pleaseAddUser: 'Please add user',
        lOrNum: 'Please enter letters or numbers',
        max15: 'Up to 15',
        max25: 'Up to 25',
        deptCode: 'Department code',
        inputDeptCode: 'Please input department code',
        deptName: 'Department name',
        inputDeptName: 'Please enter the Department name',
        supDept: 'Superior department',
        inputSupDept: 'Please enter superior department',
        lock: 'Locked',
        createBy: 'Creater',
        inputCreateBy: 'Please input Creater',
        createTime: 'Creation time',
        inputCreateTime: 'Please input the creation time',
        modifyedBy: 'Reviser',
        inputModifyedBy: 'Please input the modifier',
        editTime: 'Revision time',
        inputEditTime: 'Please input modification time',
        option: 'Operation',
      },
      sync: {
        syncAssets: 'Synchronised asset systems',
        syncABook: 'Sync Address Book',
        syncRole: 'Sync Role',
        syncContract: 'Sync Contract Systems',
        syncDept: 'Sync Department',
        syncPos: 'Sync Jobs',
        syncPeople: 'Sync Personnel',
        cloudA: 'Sync Cloud Academy',
        cloudApeople: 'Synchronous Cloud Academy (personnel)',
        cloudADept: 'Synchronous Cloud Academy (sector)',
        costcenter: 'Cost Center',
        costcenterDesc:
          'Synchronized cost center (cost center name, cost center code, cost center manager)',
        costcenterDescDept: 'Organizational Structure',
        costcenterDescDeptDesc:
          'Synchronized cost center and organizational structure relationship',
        sfBtn: 'Synchronized SF',
        bcsBtn: 'Synchronized BCS',
        bcsDesc1: 'Synchronized Cost Center',
        bcsDesc2: 'Synchronized Organizational Relationships',
        esbSys: 'ESB system',
        syncEsb: 'Sync ESB',
        syncMk: 'Sync Esc',
        syncWeWork: 'Sync weCom',
        syncAd: 'Sync AD',
        weWork: 'WeCom',
        sysOrg: 'Organizational structure',
        issBt: 'Issue',
        syncLark: 'Synchronized feishu',
        umsIss: 'MDM data distribution',
        desc1:
          'Full synchronous 7-tier organizational structure, post, functional post and workplace',
        desc2: 'Incremental synchronization of personnel information (add, modify, quit)',
      },
      mes: {
        isSync: 'Are you sure you want to synchronize？',
        isIss: 'Are you sure to send it ？',
      },
      table: {
        defaultRole: 'Default role for all',
        cata: 'Catalog',
        menu: 'Menu',
        btn: 'Button',
        sn: 'Number',
        menuName: 'Menu name',
        menuNameEn: 'Menu Name En',
        menuNameInput: 'Name of the menu',
        menuNameEnInput: 'En Name of the menu',
        name: 'Name',
        accountName: 'Name',
        email: 'Domain account',
        mobile: 'Mobile phone number',
        dept: 'Department',
        icon: 'Icon',
        iconInput: 'Please input the icon name',
        type: 'Type',
        url: 'Address',
        perm: 'Authority identification',
        sysName: 'System',
        roleName: 'Role name',
        roleNameIn: 'Please input the role name',
        sysType: 'Select system type',
        description: 'Role description',
        descriptionIn: 'Please input the role description',
        member: 'Member',
        memberSel: 'Select members',
        memberSelAxios: 'Fuzzy query after inputting member nickname',
        right: 'Permission',
        addFormOrg: 'Add through internal organizational structure',
        addFormWeb: 'Add through external organizational structure',
        leMenu: 'Superior menu',
        menuType: 'Menu type',
        menuTypeSel: 'Please select the menu type',
        urlN: 'Link address',
        urlNInput: 'Please input the address!',
        permsNInput: 'Please input the permission id!',
        sort: 'Sort',
        sortInput: 'Please select number',
      },
    },
    vir: {
      roleTab: {
        resRole: 'Responsible role',
        code: 'Role code',
        name: 'Role name',
        teamIds: 'Team name',
        nameEn: 'Role name(en)',
        roleDesc: 'Role description',
        teamName: 'Team name',
      },
      teamTab: {
        editRole: 'Edit role',
        addRole: 'Create role',
        cancel: 'Cancel',
        save: 'Save',
        roleConfig: 'Role configuration',
        teamBasicInfo: 'Team basic information',
        teamRoleConfig: 'Team role information',
        createTeam: 'Create team',
        createRole: 'Create role',
        search: 'Search',
        reset: 'Reset',
        team: 'Team',
        role: 'Role',
        edit: 'Edit',
        del: 'Delete',
        placeholderInput: 'Please input',
        placeholderSelect: 'Please select',
        sn: 'Number',
        code: 'Team coding',
        name: 'Team name',
        nameEn: 'Team name(en)',
        teamDesc: 'Team description',
        createTime: 'Creation time',
        createBy: 'Creator',
        modifiedTime: 'Last modified',
        modifiedBy: 'Last modified by',
        enable: 'State',
        enable1: 'Normal',
        enable0: 'Disable',
        type: 'Type',
        parentCode: 'Superior team',
        opt: 'Operation',
        mustMsg: 'Required',
        maxText20: 'No more than 20 words in length',
        maxText500: 'The length shall not exceed 500 words',
      },
      bulkImport1: 'Batch import internal users',
      bulkImport2: 'Batch import external users',
      bulkImport3: 'Batch import internal organizations',
      bulkImport4: 'Batch import external organizations',
      hold1: 'Product line / sub product line / product / personnel / project',
      pLine: 'Product line',
      cpLine: 'Sub product line',
      pro: 'Product',
      project: 'Project',
      editPeo: 'Edit',
      showMore: 'More',
      virManage: 'Virtual organization management',
      showTeamInfo: 'View team details',
      logout: 'Log out',
      tips: 'Tips',
      sureOut: 'Do you really want to log out?',
      signOut: 'Sign out',
      refresh: 'Refresh',
      closeLeft: 'Close left',
      closeRight: 'Close right',
      closeOther: 'Close other',
      closeAll: 'Close All',
      professional: 'The panel',
      professionalLeader: 'Expert Group Leader',
      proLineLeader: 'Product line leader',
      productLeader: 'Product leader',
      projectLeader: 'Project leader',
      login: {
        welcome: 'Welcome to MDM',
        account: 'Account',
        password: 'Password',
        code: 'Verification Code',
        login: 'Login',
        loginFail: 'Login failed; Please check your username and password',
        inputAc: 'Please input account',
        inputPs: 'Please input password',
        inputCode: 'Please input verification code',
        slogan: 'Knowledge Share Center',
        userError: 'Login failed; Please check your username and password',
        langSwitch: 'Language Switch',
        langMessage: 'Current language: English',
      },
    },
    cost: {
      totalNum: '({0} people in total）',
      costCenterName: 'Cost center name',
      description: 'Cost center description',
      costCenterCode: 'Expense Cost Center Code',
      fCostCenterName: 'Expense Cost Center Name',
      salaryCostCenterCode: 'Payroll cost center code',
      salaryCostCenterName: 'Payroll cost center name',
      costCenterPla: 'Please enter the cost center name/code',
      costCenter: 'Cost center',
      costCentreLeaderPla: 'Please enter the head of the cost center.',
      companyCode: 'Company code',
      profitCenter: 'Profit center',
      effectiveDate: 'Effective date',
      disableDate: 'Expiration date',
      createTime: 'Creation date',
      typeCN: 'Type',
      modifiedTime: 'Modified Date',
      modifiedBy: 'Modifier',
      isDeleted: 'Delete',
      matchRelate: 'Match RC',
      search: 'Search',
      searchPla: 'Please enter cost center',
      reset: 'Reset',
      export: 'Export',
      user: 'User',
      userPla: 'Name/Phone',
      status: 'Status',
      name: 'Name',
      beToCostCentre: 'Owning cost center',
      costCentreCode: 'Cost center code',
      costCentreLeader: 'Cost center manager',
      contractSubject: 'Contract Subject',
      beDept: 'Department',
      lLeader: 'Direct superior',
      phone: 'Phone',
      pos: 'Post',
      level: 'Post level',
      commonPos: 'Permanent work place',
      userStatus: 'Employee status',
      userType: 'Employee category',
      comSub: 'Corporate entity',
      salarySub: 'Payroll Company',
      sureAndCon: 'OK and continue',
      sure: 'Save',
      cancel: 'Cancel',
      selCom: 'Please select the contract subject',
      selSub: 'Please select a corporate entity',
    },
    material: {
      textPld: 'Please enter',
      selectPld: 'Please select',
      searchMPNPld: 'Manufacturer or MPN',
      searchPartPld: 'Material number or material name',
      material: 'Materials',
      close: 'Close',
      Category: 'Classify{count}',
      designer: 'Designer',
      effective: 'Is it effective',
      designDate: 'Design date',
      invalidTime: 'Date of expiration',
      validTime: 'Effective date',
      versionResume: 'Version resume',
      partId: 'Material number',
      unitName: 'Unit',
      chinaName: 'Material name',
      spec: 'Specifications',
      description: 'Description',
      source: 'Property',
      typeName: 'Classify',
      manufacturer: 'Manufacturer',
      MPN: 'Manufacturer MPN',
      searchKeyHold: 'Material code or name fuzzy search',
      search: {
        search: 'Search',
        reset: 'Reset',
        cancel: 'Cancel',
      },
      partVar: 'Version',
      sourceName: 'Property',
      partStatus: 'Usage status',
      kindName: 'Kind',
      workingTemperature: 'Operating temperature',
      SMD: 'Humidity sensitivity level',
      ESD: 'Electrostatic protection ESD',
      partGrade: 'Material Grades',
      process: 'The process',
    },
    feishu: {
      pla: {
        nameP: 'Please enter the employee name',
        plaXin: 'Please enter the last name Pinyin, case-insensitive',
        plaName: 'Please enter the first name Pinyin, case-insensitive',
        plaFull: 'Please enter the name pinyin, case-insensitive',
        input: 'Please enter',
        select: 'Please select',
        inputAppName: 'Please enter the app name.',
      },
      employeeInfo: 'Employee information',
      accountInfo: 'Account information',
      basicInfoSF: 'Basic information(sf)',
      basicInfoFS: 'Basic information(Feishu Personnel)',
      basicInfoExtra: 'Basic information(External users)',
      perInfo: 'Personal information',
      name: 'Name',
      nameEn: 'Name(EN)',
      xingPinyin: 'Last name (Pinyin)',
      mingPinyin: 'First name (Pinyin)',
      namePinyin: 'Name(Pinyin)',
      mobile: 'Mobile',
      gender: 'Gender',
      idNumber: 'ID No',
      userInfo: 'User information',
      account: 'Account',
      entryDate: 'Entry date',
      userType: 'User type',
      dockingPeople: 'Docker',
      post: 'Post',
      workPlace: 'Workplace',
      belongDept: 'Organization:',
      postLevel: 'Post level',
      immediateSuperior: 'Direct superiors',
      validateDate: 'Validity period',
      remark: 'Remark',
      enabled: 'Enabled',
      disabled: 'Disable',
      isSure: 'Confirm the action?',
      user: 'User',
      userHold: 'Username/account/mobile phone number',
      sn: 'SN',
      userName: 'User name',
      email: 'Contact email',
      tags: 'tags',
      createDate: 'Creation time',
      modifyDate: 'Last modified',
      modifyBy: 'Last modified by',
      operator: 'Operation',
      cancel: 'Cancel',
      save: 'Save',
      btn: {
        createUser: 'New external user',
        createDept: 'New department',
        hasStop: 'Disabled',
        search: 'Search',
        reset: 'Reset',
        stop: 'Stop',
      },
      onJob: 'On the job',
      offJob: 'quit',
      userId: 'User ID',
      departmentNamePath: 'Department',
      userStatus: 'Personnel status',
      userTypeText: 'Personnel type',
      edit: 'Edit',
      workNum: 'Work number',
      Assistant: 'Assistant',
      clickEdit: 'Click to edit',
      emailError: 'Please enter the correct mailbox.!',
      mainUser: 'Head',
      openApp: 'Open application',
      openAppPer: 'Open App Permissions',
      appName: 'Application name',
      validateRange: 'Account permission validity period',
      appPerm: 'Apply permissions',
      accountStatus: 'Account Status',
      openTime: 'Opening time',
      openBy: 'Opened',
      loginDate: 'Last login time',
      delApp: 'Unopening',
      male: 'Male',
      female: 'Female',
      Supplier: 'Suppliers',
      Partners: 'Partners',
      addUser: 'Add employee',
      correctEmail: 'Please enter the correct mailbox.',
      show: 'Show',
      idCards: {
        cardType1: '+ID card',
        cardType2: '+Hong Kong and Macao Pass',
        cardType3: '+Taiwan Pass',
        cardType4: '+Passport',
        cardType5: '+Other',
      },
      accountStatuses: {
        status1: 'Normal',
        status2: 'Change the password freeze',
        status3: 'Check freeze',
        status4: 'Disable',
        status5: 'Information to be completed',
      },
      isSureUnbind: 'Confirm unopen？',
      table: {
        deptName: 'Department Name',
        createDate: 'Creation time',
        createPelple: 'Created by',
        updateDate: 'Update time',
        updatePelple: 'Update by',
        option: 'Operate',
        optTime: 'Operation time',
        dataType: 'Module',
        userName: 'Name',
        changeSource: 'Source',
        type: 'Modify Type',
        theme: 'Modify field',
        oldContent: 'Pre-modification',
        newContent: 'Modified content',
        enableDatetime: 'Effective time',
        disableDatetime: 'Invalid time',
      },
      all: 'All',
      allData: 'All information',
      changeLog: 'Change record',
      changeSource: 'Source',
      nameInfo: 'Enter name',
      dataType: 'Data type',
      dataTypes: {
        type1: 'Employee data',
        type2: 'Departmental data',
        type3: 'Account data',
        type4: 'User data',
        type5: 'Account opens application',
        type6: 'Account association data',
        type7: 'User Cost Center',
        type8: 'Department-related data',
        type9: 'Department Manager Data',
        type10: 'Temporary user data',
        type11: 'Outsourcing data',
        type12: 'Account associated with external ID',
      },
      sources: {
        type1: 'Human operation',
        type2: 'Timed task update',
        type3: 'Process engine',
        type4: 'Message queue processing',
      },
      editTypes: {
        type1: 'New',
        type2: 'modify',
        type3: 'Logical delete',
        type4: 'Physical deletion',
      },
      noEmptyData: 'Data Item Cannot Be Empty',
      createUser: 'Create user',
      createAccount: 'Create account',
      openPerm: 'Open permissions',
      continueCA: 'Continue to create an account',
      previewStep: 'Previous',
      pDeptSel: 'Please select your organization',
      pUserSel: 'Please enter the docker.',
      onlyLetter: 'Please enter letters.',
      spellError: 'Name Pinyin input error',
      noSpecText: 'Unable to enter special characters',
      onlyNumber: 'Please enter a number',
    },
    appManage: {
      sn: 'SN',
      name: 'Application name',
      enName: 'English application name',
      appUrl: 'Application address',
      appDesc: 'Application description',
      Administrator: 'Administrator',
      status: 'Application status',
      visibleRange: 'Visibility range',
      availablePeople: 'Available person id',
      availableDept: 'Available department id',
      operator: 'Operate',
      createApp: 'Create application',
      pla: {
        must: 'Required',
        name: 'Please enter the app name/administrator',
        appName: 'Please fill in the app name.',
        enName: 'Please fill in the application English.',
        url: 'Please fill in the application address.',
        desc: 'Please fill in the application description.',
        admin: 'Add administrator',
        adminId: 'Enter the person id separated by commas.',
        deptId: 'Enter the department id separated by commas.',
      },
      appStatuses: {
        status1: 'In development',
        status2: 'Running.',
        status3: 'Offline',
      },
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      basicInfo: 'Basic information',
      roleManage: 'Role management',
      clickEdit: 'Click to edit',
      noEmptyData: 'Data Item Cannot Be Empty',
      copySuccess: 'Successful copy',
      copy: 'Copy',
      copyFail: 'Copy failed, please try again',
    },
  },
  app: {
    lang: {
      langSwitch: 'Language Switch',
      langMessage: 'Current language: English',
    },
    account: {
      center: 'Center',
      help: 'Help',
      settings: 'Setting',
      lang: 'Language switching',
      logout: 'Logout',
      dialog: {
        title: 'Tip',
        content: 'Are you sure logout?',
      },
    },
  },
  productLine: {
    fix: {
      project: 'project',
      productName: 'Product name',
      productCode: 'Product code',
      belongToLine: 'Product line',
      type: 'type',
      belongToChildLine: 'Subproduct lines',
      belongDept: 'Subordinate departments',
      productLeader: 'Product owner',
      pStartTime: 'Expect start time',
      pEndTime: 'Expect end time',
      sopTime: 'SOP time',
      proDesc: 'Product desc',
      projectName: 'Project name',
      projectCode: 'Project code',
      projectLeader: 'Project leader',
      projectDesc: 'Project desc',
    },
    org: {
      code: 'code',
      childProLineLeader: 'Sub-product line leader',
      childProLinePdt: 'Director of Sub-Product Line',
      ipmtLeader: 'IPMT, director of the',
      productLineLeader: 'Product line leader',
      IPMTMembers: 'IPMT members',
      proLineSearch: 'Product line / sub product line / product',
      input: 'Please input',
      choose: 'Please select',
      proLine: 'Product line',
      proChildLine: 'Sub Product line',
      product: 'Product',
      proLineName: 'Name',
      departmentAffiliated: 'Department',
      type: 'Service line',
      startOrNot: 'Enable or not',
      proLineDesc: 'Description',
      visualRange: 'Visible range',
      team1: 'ProductLineTeam',
      team2: 'ProductChildLineTeam',
      team3: 'ProductTeam',
      setting: 'Setting',
      proChildLineName: 'Name',
      proLineAffiliated: 'Product line',
      proChildLineDesc: 'Description',
      productCode: 'Product code',
      planeStartTime: 'Start time',
      planeEndTime: 'End time',
      SopTime: 'SOP',
      productDesc: 'Product description',
      addProLine: 'Add Product line',
      editProLine: 'Edit Product line',
      copyProLine: 'Copy Product line',
      addChildProLine: 'Add Sub Product line',
      editChildProLine: 'Edit Sub Product line',
      checkProduct: 'Check Product',
      checkProject: 'Check Project',
      expotrFile: 'Product Line.xlsx',
    },
    btn: {
      check: 'Check',
      edit: 'Edit',
      copy: 'Copy',
      limit: 'Limits',
      del: 'Delete',
      cancel: 'Cancel',
      submit: 'Submit',
      sure: 'OK',
      show: 'Check',
      search: 'Search',
      advanceSearch: 'Senior Filter',
      reset: 'Reset',
      sync: 'Syn',
      save: 'Save',
      sureDel: 'Are you sure you want to delete more?',
      svaeC: 'Save and continue',
    },
    mes: {
      comSys: 'General system',
      sureDel: 'Are you sure you want to delete',
      isDelSelData: 'Are you sure you want to delete the selected data?',
      syncSys: 'Please select the system to synchronize!',
      atLeastOne: 'Please select a piece of data to delete',
      atLeastEdit: 'Please select at least one piece of data to edit',
      copyConfirmTitle1: 'The information of the',
      copyConfirmTitle2:
        'product line, PDT and LMT  will be copied to the new product line. Are you sure you want to copy the information of this product line?',
    },
  },
  feedback: {
    feedback1: 'Feedback',
    satisfied: 'Hi, are you satisfied with us?',
    complaints: 'Any complaints, suggestions, etc. are welcome',
    send: 'Send',
    thanks: 'Thanks for your feedback.',
    nice: 'Hi, nice to meet you. If you have any questions, please give feedback here!',
    upload: 'upload',
    anOther: 'One more',
    close: 'later closed automatically',
    help: 'Help document',
    it: 'IT Help Desk',
    vbad: 'Very bad！',
    notgood: 'Not good',
    justsoso: 'Just so-so',
    Nice: 'Nice！',
    Excellent: 'Excellent！',
  },
  'authority:my:view': 'My Permission',
  'authority:view': 'Personnel Permission',
  'authority:point:view': 'Permission Management',
  'authority:role:view': 'Role Management',
  'authority:subordinate:view': 'Subordinates Permission',
  'authority:menu:view': 'Menu Management',
  'authority:report:view': 'Review Report',
  'authority:group:report': 'Group Review Report',
  'authority:task:report': 'Employee Review Report',
  'authority:log:view': 'Permission Log',
  'log:rolePoint:view': 'Role/Permission Log',
  'log:person:view': 'Personnel Log',
};
